import axiosClient from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const fetchContents = createAsyncThunk(
  'sections/fetchContents',
  async ({ sectionId, contentType }, { rejectWithValue }) => {
    try {
      const url = `/api/section/${sectionId}/${contentType}/contents`;
      const response = await axiosClient.get(url);
      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export default fetchContents;
